// extracted by mini-css-extract-plugin
module.exports = {"update":"updateDate_update__dyZDr","date":"updateDate_date__3xh5Q"};